<script setup lang="ts">
import type { Team } from '~/types'

interface Props {
  team: Team.Model
}

const props = defineProps<Props>()

const { styles } = useTeam(props.team)
</script>

<template>
  <main :style="styles">
    <SkipLink />
    <Header :team />
    <HeaderTeam :team />
    <div
      id="main-content"
      class="main-content"
    >
      <slot />
    </div>
    <Footer />
    <ClientOnly>
      <AdminBar />
    </ClientOnly>
  </main>
</template>
